import {useQuery, useMutation} from 'react-query'
import { IQueryOption } from '../type'
// import { URL_BASE_RBAC } from '../config'
import { api } from './base'

type GetRolesParamsType = IQueryOption
type GetRoleParamsType = { uuid: string; }
export const useQueryRoles = (queryParams?: GetRolesParamsType) => useQuery<any> (
  [
    'rdac/roles', 
    !queryParams ? null : { ...queryParams }
  ],
  async ({signal}) => {
    const {
      pageNumber, searchKeyWords, sort,
    } = queryParams || {}
    // console.log('queryRoles')
    // console.log({signal})
    const result = await api.get('/auth/role', {
      signal,
      params: !queryParams ? undefined : {
        page: pageNumber,
        sort,
        filter: { search: searchKeyWords },
        paginate: true,
        perPage: 10,
      },
    })
    return result?.data
  },
  {keepPreviousData: true}
)

export const useQueryRoleDetails = ({
  uuid
}: GetRoleParamsType) => useQuery<any> (
  [
    'rdac/role/details', 
    { uuid }
  ],
  async ({signal}) => {
    // console.log('queryRoleDetails')
    // console.log({signal})
    const result = await api.get(`/auth/role/${uuid}`, {
      signal,
    })
    return result?.data
  },
  {keepPreviousData: true}
)

type UpdatePayloadType = {
  roleId: string;
  permissions: string[];
}
const update = (payload:UpdatePayloadType) => api.post(
  `/auth/role/edit`,
  payload,
)
export const useUpdate = () => useMutation(
  update,
  {
    onSuccess(res:any) {
      console.log('onSuccess', res)
    },
  }
)
